import imgCropUrl from '@/home/utils/imgCropUrl';
import TrackWrapper from '~/components/common/TrackWrapper';
import { useIsMobile } from '~/context/common/DeviceContext';
import { BffFeedCardProps } from '~/contracts/home';
import { nativeMyCarsPayload } from '~/native/home/utils';
import { defaultImageHandler } from '../../utils/defaultImageHandler';
import formatEvent from '../../utils/formatEvent';
import {
  Card,
  CardButtonBlue,
  CardDescription,
  CardHeader,
  CardImageSection,
  CardInfoSection
} from '../OrderStatusCards.styles';

function PostDeliverVehicleDetails({ feedItem }: BffFeedCardProps) {
  if (
    feedItem.callToAction == null ||
    feedItem.content == null ||
    feedItem.content.vehicle == null
  ) {
    return null;
  }

  const {
    callToAction: { title: callToActionTitle, link: callToActionLink },
    content: {
      vehicle: { make, model, trim, year, id: vehicleId }
    }
  } = feedItem;

  return (
    <>
      <div className="card-vehicle-details m:mb-20">
        <p className="leading-6 s:tl-header-s m:tl-header-s l:tl-header-m">
          {year} {make} {model}
        </p>
        <p className="text-grey-5 s:tl-body-s">{trim}</p>
      </div>
      <CardButtonBlue
        href={callToActionLink}
        data-analytics-id="Home feed card"
        data-analytics-attributes={JSON.stringify({
          description: 'Purchased vehicle cta',
          vehicleId
        })}
        data-native-payload={nativeMyCarsPayload}
      >
        {callToActionTitle}
      </CardButtonBlue>
    </>
  );
}

export default function PurchasedVehicleCard({ feedItem }: BffFeedCardProps) {
  const isMobile = useIsMobile();

  if (
    feedItem.callToAction == null ||
    feedItem.content == null ||
    feedItem.content.vehicle == null
  ) {
    return null;
  }

  const {
    callToAction: { link: callToActionLink },
    content: {
      vehicle: { imageUrl, make, id: vehicleId }
    }
  } = feedItem;

  const customAttributes = {
    description: 'Purchased vehicle cta',
    vehicleId
  };

  return (
    <TrackWrapper
      event={formatEvent('Viewed - Home feed card', customAttributes)}
    >
      <Card data-qa="purchase-in-progress-card">
        <CardInfoSection>
          <CardHeader className="tl-header-m m:tl-header-xl">
            Congrats on your new {make}!
          </CardHeader>
          <CardDescription className="pt-12 m:mb-16 m:tl-body-m">
            Everything for your car, all in one place. View your registration
            status, report an issue and more.
          </CardDescription>
          {!isMobile && <PostDeliverVehicleDetails feedItem={feedItem} />}
        </CardInfoSection>

        <CardImageSection>
          <a
            href={callToActionLink}
            data-analytics-id="Home feed card"
            data-analytics-attributes={JSON.stringify(customAttributes)}
            data-native-payload={nativeMyCarsPayload}
          >
            <picture>
              <source
                srcSet={imgCropUrl(imageUrl, false)}
                media="(min-width=768px)"
              />
              <source
                srcSet={imgCropUrl(imageUrl, true)}
                media="(min-width=320px)"
              />
              <img
                data-qa="post-sale-card-image"
                className="h-full w-full rounded-md object-cover"
                alt="Vehicle"
                src={imgCropUrl(imageUrl, true)}
                onError={defaultImageHandler}
              />
            </picture>
          </a>
        </CardImageSection>

        {isMobile && <PostDeliverVehicleDetails feedItem={feedItem} />}
      </Card>
    </TrackWrapper>
  );
}
